import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { User } from 'src/app/shared/models';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesComponent extends DestructorComponent implements OnInit {
  salesChildren: Route[] = [];
  user: User | null = null;

  constructor(private router: Router, private _globalStateService: GlobalStateService) { super(); }

  ngOnInit(): void {
    let salesRoute:any = this.router.config.find(r => r.path === 'sales');

    salesRoute.children = salesRoute.children.filter((child: any) => {
      return child.data?.showInActions !== false;
    });
    // Get only first-level children
    let routeSalesChildren = salesRoute?.children ?? [];


    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if (this.user?.role_complete.is_admin) {
          this.salesChildren = salesRoute?.children ?? [];
        }
        else {
          this.salesChildren = routeSalesChildren.filter((child: any) => {

            return this.user?.role_complete.permissions[child.path]?.view;
          });
        }
      })
    );
  }
}
